import React from 'react';
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { fetchImmunizationResultsThunk, setErrorState } from '../actions/api'
import BackButton from '../components/backButton'
import BackButtonMobile from '../components/backButtonMobile'
import Loading from '../components/loading'
import NavBar from '../components/navbar'
import Footer from '../components/footer'
import ImmunizationsSideInfo from '../components/immunizationsSideInfo'
import ImmunizationsLowerInfo from '../components/immunizationsLowerInfo'
import { getTargetLanguage, LANG_EN, LANG_FR } from '../util/language_v3'


import tmpImmunizationImage from '../images/ic-results.png';
import invalidImmunizationImage from '../images/INVALIDIMMUNIZATION.png'
import tmpNoResultsImage from '../images/ic-results.png';
import tmpCovidIcon from '../images/POSITIVE.svg';
import locationIcon from '../images/ic_location_on.png';
import tmpHeaderIcon from '../images/ic-results.png';
import timerIcon from '../images/ic_access_time.png'
import immunizationIcon from '../images/immunization-icon.png';
import printIcon from '../images/print-icon.png';
import * as settings from '../globals/settings'

import is, { propertyDefined } from 'is_js'
import { formatDate } from '../util/util';

class ImmunizationScreen extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            sendLoginAlert: false
        }
    }

    componentDidMount() {
        if (settings.DEBUG == "true")
            return;

            this.props.dispatch(fetchImmunizationResultsThunk())
            .catch(err => {
                if(err !== null && err !== undefined){
                    if(err.code === 'ARE' || err.code === 'ADE'){
                        this.setState({sendLoginAlert: true})
                    } else if(err.code === 'SIE'){
                        this.props.dispatch(setErrorState(true, err.message, true));
                    } else if(err.code === 'MIE'){
                        this.props.dispatch(setErrorState(true, err.message, true));
                    } else if(err.code === 'LREE'){
                        this.props.dispatch(setErrorState(true, err.message, true));
                    } else if(err.code === 'DAE'){
                        this.props.dispatch(setErrorState(true, err.message, true));
                    } else if(err.code === 'PVE'){
                        this.props.dispatch(setErrorState(true, err.message, true));
                    } else {
                        this.props.history.push("/");
                    }
                }
            });
    }

    render() {
        if (this.props.isError === true) {
            return <Redirect to="error" />
        }
        // FIXME Remove fake login!!!
        if ((this.props.isLoggedIn !== true && this.props.isFakeLoggedIn !== true) || this.state.sendLoginAlert) {
            return <Redirect to={{
                pathname: "/",
                state: { loginAlert: this.state.sendLoginAlert }
            }}/>
        }
        if (this.props.isLoadingImmunizationResults === true) {
                return <Loading />
        }

        let results = this.props.immunizationResults.map(i => <ImmunizationResult {...i} language={this.props.language} strings={this.props.strings}/>)
        if(results.length === 0){
            results = <NoResult strings={this.props.strings}/>
        }

        return (
            <div className="container-full">
                <NavBar isLoggedIn={this.props.isLoggedIn} language={this.props.language}/>
                <div className="container topPadding">
                  <BackButtonMobile/>
                    <div className="col" id="first">
                        <div class="row wBorder">
                          <ImmunizationsSideInfo showPrint={true}/>
                          <div className="col-12 col-md-9 order-1 order-md-1 order-lg-1 noMargin">
                            <BackButton/>
                                    <div className="titleBoxImm">
                                        <div class="testIcon"><img src={immunizationIcon} width="30" /></div>
                                        <h4>{this.props.strings.IMMUNIZATIONS_HEADER}</h4>
                                    </div>
                                {results}
                                <ImmunizationsLowerInfo/>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        user: state.api.user,
        strings: state.language.strings,
        language: state.language.language,
        isLoggedIn: state.auth.isLoggedIn,
        isFakeLoggedIn: state.auth.isFakeLoggedIn,
        isLoadingImmunizationResults: state.api.isLoadingImmunizationResults,
        immunizationResults: state.api.immunizationResults,
        isError: state.api.isError,
        deviceType: state.api.deviceType,
    }
}

function ImmunizationResult(props){
    let styles= "row resultBox";
    if (props.immunizationStatus === "Invalid"){
        styles += " invalidImmunizationResultBox"
    }

    return (
    <div class={styles}>

        <div className="col-7 col-sm-8 col-md-8 col-xl-10">
            <div className="section">
                <div className="row vAlign">
                    <h5>{props.language===LANG_EN? props.immunizationName:props.immunizationNameFr}</h5>
                </div>
            </div>
        </div>
        <div className="col-5 col-sm-4 col-md-4 col-xl-2 ml-auto vAlign vAlignMobile">
            <div className="section immDate">
                    {formatDate(props.immunizationDate, props.language)}
            </div>
        </div>
        <div className="vAlign col-12">
            {props.immunizationStatus === "Invalid" ? renderInvalidImmunization(props.strings) : null}
        </div>
    </div>
    )
}

function renderInvalidImmunization(strings){
    return(
        <div className = "invalid-information-box">
            <p>
                <span className="xIcon"><img src={invalidImmunizationImage} width="25"></img></span>
                <strong>{strings.INVALID_IMMUNIZATION_DESC_1}</strong>{strings.INVALID_IMMUNIZATION_DESC_2}<a target="_blank" href ={strings.INVALID_IMMUNIZATION_LINK}>{strings.INVALID_IMMUNIZATION_DESC_3}</a>{strings.INVALID_IMMUNIZATION_DESC_4}
            </p>
        </div>
    )
}

// Pretty much the same as an ImmuizationResult but split in case they diverge stylistically
function NoResult(props){
    const strings = props.strings
    return (
        <div class="row">
            <div className="col-12">
                <div className="noResults">{strings.IMMUNIZATIONS_NO_RESULTS_DESC}</div>
            </div>
            <div className="col-12 col-md-6 ml-auto">
                <div className="section">
                    {/* <div className="row" style={{verticalAlign:"middle"}}>
                        <div class="testIcon">
                            <img src={tmpImmunizationImage} width="10"/>
                        </div>
                        {strings.IMMUNIZATIONS_NO_RESULTS_TITLE}
                    </div> */}
                </div>
            </div>
            <div className="col-12 col-md-3 ml-auto">
                <div className="section" style={{verticalAlign:"middle"}}>
                </div>
            </div>
        </div>
    )
}

export default connect(mapStateToProps)(ImmunizationScreen)
